__turbopack_context__.v({
  "advancedSearchItem": "AdvancedSearchItem-module__j40EAW__advancedSearchItem",
  "queryText": "AdvancedSearchItem-module__j40EAW__queryText",
  "row": "AdvancedSearchItem-module__j40EAW__row",
  "shortcut": "AdvancedSearchItem-module__j40EAW__shortcut",
  "text": "AdvancedSearchItem-module__j40EAW__text",
  "textIcon": "AdvancedSearchItem-module__j40EAW__textIcon",
});
